import sharedProps from '../../../../props/profile/cards'

const addCardProps = {
  initAddCardButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('addCard.init.title', 'Add one more Gift Cards') //@change: initAddCardButtonTitle / addedCardButtonTitle
    }
  },
  purchaseCardButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('purchaseCard.button.title', 'Purchase a new gift card') //@change: purchaseCardButtonTitle
    }
  },
  archivePurchaseCardButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('archive.purchaseCard.button.title', 'Purchase a gift card') //@added:
    }
  },
  purchaseCardButtonLink: {
    type: [String, Object],
    default() {
      return this.$options.$$s('purchaseCard.button.link', {name: 'giftcards.buy'}) //@change: purchaseCardButtonLink
    }
  },

  addCardButtonTitle: {
    type: String,
    default() {
      return this.$options.$$t('addCard.button.title', 'Add gift card') //@change: addCardButtonTitle
    }
  },
  addCardModalTitle: {
    type: String,
    default() {
      return this.$options.$$t('addCard.modal.title', 'Add Gift Card') //@change: addCardModalTitle
    }
  },
  addCardSuccessModalTitle: {
    type: String,
    default() {
      return this.$options.$$t('addCard.modal.successTitle', 'Your Gift Card has been added.') //@change: addCardSuccessModalTitle
    }
  },
}

const reloadCardProps = {
  reloadCardRoute: {
    type: [String, Array, Object],
    default() {
      return this.$options.$$s('reload.route', {name: 'playcard.reload'})
    }
  },
  reloadCardType: {
    type: String,
    default() {
      return this.$options.$$s('reload.type', 'giftcard_reload')
    }
  },
}
const cardFeatureProps = {
  showStatus: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showStatus', true) //@added:
    }
  },
  showBalance: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showBalance', true) //@added:
    }
  },
  showNumber: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showNumber', true)  //@added:
    }
  },
  showNumberMasked: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showNumberMasked', true)  //@added:
    }
  },
  maskedNumber: {
    type: String,
    default() {
      return this.$options.$$t('card.mask', this.$options.$$s('card.mask', null))  //@added:
    }
  },
  showTicket: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showTicket', false)  //@added:
    }
  },
  showBonus: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showBonus', false)  //@added:
    }
  },
  showPoints: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showPoints', false)  //@added:
    }
  },
  showRecipient: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showRecipient', true) //@added:
    }
  },
  showGiver: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.showGiver', true) //@added:
    }
  },

  allowReload: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.allowReload', true) //@added:
    }
  },
  allowClaim: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.allowClaim', true) //@added:
    }
  },
  allowForgotCode: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.allowForgotCode', true) //@added:
    }
  },
  allowResend: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.allowResend', true) //@added:
    }
  },
  allowArchive: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('card.allowArchive', true) //@added:
    }
  },

}

const modalProps = {
  numberInfoModalFooter: {
    type: String,
    default() {
      return this.$options.$$t('numberInfoModalFooter', 'The Gift Card number can be found in the email that was sent after the purchase was done or under the \'My Cards\' section of your Account.')
    }
  },
  codeInfoModalFooter: {
    type: String,
    default() {
      return this.$options.$$t('codeInfoModalFooter', 'The CVV or Card Code can be found in the email that was sent after the the gift card was claimed by you.')
    }
  },
}

const genericProps = {
  emptyCardMessage: {
    type: String,
    default() {
      return this.$options.$$t('emptyCardMessage', 'No Gift Card has been associated to this account. To add a Gift Card click the button above.')
    }
  },
  showLocationFilter: {
    type: [Boolean, Number, String],
    default() {
      return !!this.$options.$$s('showLocationFilter', false)
    }
  },
  emptyFilteredCardMessage: {
    type: String,
    default() {
      return this.$options.$$t('emptyFilteredCardMessage', 'No card has been associated to this location. To add a card click the button above.')
    }
  },
}

export const props = {
  ...sharedProps,

  ...addCardProps,
  ...reloadCardProps,
  ...modalProps,
  ...cardFeatureProps,
  ...genericProps
}

export default props
